export const HISTORY = 'HISTORY';

export const history = (stats: any) => ({
  type:HISTORY,
  payload: stats
});